import React, { FC, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  Container,
  Grid,
  Button,
  Paper,
  Typography,
} from "@material-ui/core";
import UserModel from "../../models/user-model";
import moment from "moment";
import { LocalAtm, InfoOutlined } from "@material-ui/icons";
//imports
import Title from "../../components/Title";
import { getOrderDetail, cancelOrder, resetOrderStatus } from "../../flux/actions/order-actions";
import { useStyles } from "./styles";
import ScreenLoader from "../../components/ScreenLoader";
import { OrderStatus } from "../../constants/orderDetails-constants";
import { ProductModel } from "../../models/product-model";
import ConfirmDialogComponent from "../../components/Modal/ConfirmDialogComponent";
import SnackBarAlert from "../../components/Alert/AlertComponent";

const OrderDetail: FC<RouteComponentProps> = ({ match: { params } }) => {
  //initialize styles
  const classes = useStyles();
  const dispatch = useDispatch();
  //User information
  const user: UserModel = useSelector((state: any) => state.authReducer.user);
  const orderId = (params as any)?.id;

  const {loading, orderDetail, success, successMessage} = useSelector((state: any) => state.order);
  const [orderStatus, setOrderStatus] = useState("");
  const [showCancelModal, setShowCancelModal] = useState(false)

  useEffect(() => {
    if (!user.email) {
      window.location.href = "/";
    }
    dispatch(resetOrderStatus())
  }, []);

  useEffect(() => {
    setOrderStatus(getOrderStatus());
  }, [orderDetail]);

  useEffect(() => {
    if (orderId) {
      dispatch(getOrderDetail(orderId));
    }
    window.scrollTo(0, 0);
  }, [dispatch, orderId]);

  const cancel_order = () => {
    const payload = {
      status: "CANCELADO"
    }

    dispatch(cancelOrder(orderId, payload))
    setShowCancelModal(!showCancelModal)
  }

  const getOrderStatus = () => {
    switch (orderDetail.order?.status) {
      case "RECIBIDO":
        return OrderStatus.RECIBIDO;
      case "ARMADO":
        return OrderStatus.ARMADO;
      case "LISTO":
        return OrderStatus.LISTO;
      case "EN_ENTREGA":
        return OrderStatus.EN_ENTREGA;
      case "TERMINADO":
        return OrderStatus.TERMINADO;
      case "RECHAZADO":
        return OrderStatus.RECHAZADO;
      case "RETENIDO":
        return OrderStatus.RETENIDO;
      case "CANCELADO":
        return OrderStatus.CANCELADO;
      default:
        return "Estatus pendiente te asignar";
    }
  };

  return loading || orderDetail.order === undefined ? (
    <ScreenLoader isOpen={true} />
  ) : (
    <Container component="main" fixed>
      <Grid container direction="row">
        <Grid sm={12} spacing={3} item className={classes.section}>
          <Title value="Detalles del Pedido " />
        </Grid>
        <Grid
          container
          spacing={3}
          className={classes.clientInfo}
          direction="row"
        >
          <Grid item sm={12} md={6} className={classes.addressGrid}>
            <Paper className="addressPaper">
              <Grid container spacing={3}>
                <Grid className={classes.orderTitleGrid} item sm={12} md={12}>
                  <Typography className={classes.orderInfoTitle} variant="h5">
                    <b>Información de contacto</b>
                  </Typography>
                </Grid>
                <Grid className={classes.orderInfoLabelGrid} item xs={6} md={4}>
                  <strong>Nombre</strong>
                </Grid>
                <Grid className={classes.orderInfoGrid} item xs={6} md={8}>
                  {orderDetail.order.userDetails.name}
                </Grid>
                <Grid className={classes.orderInfoLabelGrid} item xs={6} md={4}>
                  <strong>Teléfono</strong>
                </Grid>
                <Grid className={classes.orderInfoGrid} item xs={6} md={8}>
                  {orderDetail.order.userDetails.phone}
                </Grid>
                <Grid className={classes.orderInfoLabelGrid} item xs={6} md={4}>
                  <strong>Contacto:</strong>
                </Grid>
                <Grid className={classes.orderInfoGrid} item xs={6} md={8}>
                  {orderDetail.order.userDetails.email}
                </Grid>
                <Grid className={classes.orderInfoLabelGrid} item xs={6} md={4}>
                  <strong>Enviar a</strong>
                </Grid>
                <Grid className={classes.orderInfoGrid} item xs={6} md={8}>
                  {orderDetail.order.userDetails.address.street}, {"Colonia"}{" "}
                  {orderDetail.order?.userDetails.address.district}, {"CP"}{" "}
                  {orderDetail.order?.userDetails.address.cp},{" "}
                  {orderDetail.order?.userDetails.address.city}, {"Michoácan."}
                </Grid>
                <Grid className={classes.orderInfoLabelGrid} item xs={6} md={4}>
                  <strong>Método de pago</strong>
                </Grid>
                <Grid item xs={6} md={8} className={classes.cash}>
                  <LocalAtm style={{ color: "#D32F2F", marginRight: "5px" }} />{" "}
                  <span style={{ marginTop: "3px" }}>Efectivo</span>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item sm={12} md={6} className={classes.addressGrid}>
            <Paper className="addressPaper">
              <Grid container spacing={3}>
                <Grid className={classes.orderTitleGrid} item sm={12}>
                  <Typography className={classes.orderInfoTitle} variant="h5">
                    <b>Detalles de pedido</b>
                  </Typography>
                </Grid>
                <Grid className={classes.orderInfoLabelGrid} item xs={6} md={4}>
                  <strong>No. de pedido:</strong>
                </Grid>
                <Grid className={classes.orderInfoGrid} item xs={6} md={8}>
                  # {orderDetail.order.number}
                </Grid>
                <Grid className={classes.orderInfoLabelGrid} item xs={6} md={4}>
                  <strong>Fecha de pedido:</strong>
                </Grid>
                <Grid className={classes.orderInfoGrid} item xs={6} md={8}>
                  {moment(orderDetail.order.createdAt).format("L")}
                </Grid>
                <Grid className={classes.orderInfoLabelGrid} item xs={6} md={4}>
                  <strong>Fecha de entrega:</strong>
                </Grid>
                <Grid className={classes.orderInfoGrid} item xs={6} md={8}>
                  {moment(orderDetail.order.deliverDate).format("L")}
                </Grid>
                <Grid className={classes.orderInfoLabelGrid} item xs={6} md={4}>
                  <strong>Estatus:</strong>
                </Grid>
                <Grid className={classes.orderInfoGrid} item xs={6} md={8}>
                  {orderStatus}
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>

        <Grid item sm={12} className={classes.productGrid}>
          <Paper className="productPaper">
            <Grid container>
              <Grid className={classes.orderTitleGrid} item sm={12} md={12}>
                <Typography className={classes.orderInfoTitle} variant="h5">
                  Resumen del Pedido
                </Typography>
              </Grid>
              <Grid style={{ marginTop: "1rem", overflow: 'auto', maxHeight: '20rem'}} item sm={12} md={6}>
                {orderDetail.order &&
                  orderDetail.order.products.map((product: ProductModel) => {
                    return (
                      <Container
                        key={product.productCode}
                        className={classes.productsPaper}
                      >
                        <Box className={classes.productsBox}>
                          <Box
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <img
                              className={classes.productImage}
                              src={product.image}
                              alt={product.full_name}
                            />
                            <Box
                              marginLeft={5}
                              style={{
                                display: "flex",
                                flexDirection: "column"
                              }}
                            >
                              <Typography
                                variant="h6"
                                style={{ fontWeight: "bold" }}
                              >
                                {product.full_name}
                              </Typography>
                              <Typography
                                variant="h6"
                                style={{ color: "#D32F2F" }}
                              >
                                {`$${product.cost && product.cost.toFixed(2)}`}
                              </Typography>
                            </Box>
                          </Box>
                          <Box style={{ marginLeft: "1.5rem" }}>
                            {
                              <Box className={classes.productQty}>
                                {product.qty}
                              </Box>
                            }
                          </Box>
                        </Box>
                      </Container>
                    );
                  })}
              </Grid>
              <Grid style={{ marginTop: "3rem" }} item sm={12} md={6}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Typography
                      className={classes.orderInfoGrid}
                      variant="h6"
                      style={{ fontWeight: "bold" }}
                    >
                      <strong>Productos</strong>
                    </Typography>
                  </Grid>
                  <Grid className={classes.orderInfoGrid} item xs={6}>
                    <Typography variant="h6">
                      MXN $ {orderDetail.order.productsTotal.toFixed(2)}
                    </Typography>
                  </Grid>
                  <Grid className={classes.orderInfoGrid} item xs={6}>
                    <Typography variant="h6" style={{ fontWeight: "bold" }}>
                      <strong>Envío</strong>
                    </Typography>
                  </Grid>
                  <Grid className={classes.orderInfoGrid} item xs={6}>
                    <Typography variant="h6">
                      MXN $ {orderDetail.order.deliveryCharge.toFixed(2)}
                    </Typography>
                  </Grid>
                  <Grid className={classes.orderInfoGrid} item xs={6}>
                    <Typography variant="h6" style={{ fontWeight: "bold" }}>
                      <strong>Cupón</strong>
                    </Typography>
                  </Grid>
                  <Grid className={classes.orderInfoGrid} item xs={6}>
                    <Typography variant="h6">MXN $ -200.00</Typography>
                  </Grid>
                  <Grid className={classes.redColor} item xs={6}>
                    <Typography
                      className={classes.orderInfoGrid}
                      variant="h6"
                      style={{ fontWeight: "bold" }}
                    >
                      <strong>Total</strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography className={classes.orderInfoGrid} variant="h6">
                      <strong>
                        {" "}
                        MXN $ {orderDetail.order.orderTotal.toFixed(2)}
                      </strong>
                    </Typography>
                  </Grid>
                  <Grid md={2} />
                  {orderDetail.order?.status !== "CANCELADO" &&
                    <Grid className={classes.orderInfoGrid} item xs={12} md={10}>
                      <Button
                        className={classes.button}
                        fullWidth
                        type="button"
                        variant="contained"
                        color="secondary"
                        onClick={() => setShowCancelModal(!showCancelModal)}
                      >
                        Cancelar
                      </Button>
                    </Grid>
                  }
                </Grid>
              </Grid>
            </Grid>
          </Paper>
          <Grid sm={12} spacing={3} item className={classes.infoLayout}>
            <InfoOutlined style={{ color: "#D32F2F", marginRight: "15px"}} />{"   "}
            <Typography>
              Si tienes problema con tu pedido o deseas cambiar algún dato favor de contactar al correo <b>support@cava.com</b> o al teléfono <b>443467543</b>
            </Typography>
          </Grid>
        </Grid>
          <ConfirmDialogComponent
            isOpen={showCancelModal}
            content={orderDetail.order?.status === "RECIBIDO" ?
                      "Estas apunto de cancelar tu pedido, deseas continuar?" :
                      "Atención!! \n No se puede cancelar tu pedido, llama al teléfono 443-123-3453 o manda un correo al admin@cavadoncarlos.com"
                    }
            title={"Cancelar Pedido"}
            cancelAction={()=>setShowCancelModal(!showCancelModal)}
            confirmAction={orderDetail.order?.status === "RECIBIDO" ? cancel_order : () => setShowCancelModal(!showCancelModal)}
            tokenExpiration={false}
          />
      </Grid>
    </Container>
  );
};

export default OrderDetail;
